<template>
  <label
    v-on:click.stop.prevent="toggleCheckbox"
    :class="`bg-checkbox ${value && 'bg-checkbox--checked'} ${
      disabled && 'bg-checkbox--disabled'
    }`"
    :for="id"
  >
    <input
      type="checkbox"
      class="bg-checkbox__input"
      v-bind="{ disabled, name, required }"
      :value="checked"
    />
    <div
      :class="`bg-checkbox__check ${outline && 'bg-checkbox__check--outlined'}`"
    ></div>
    <div class="bg-checkbox__label">{{ label }}</div>
  </label>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
export default {
  name: "bg-checkbox",
  props: {
    required: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    value: [Boolean],
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: this.value,
    };
  },
  watch: {
    value() {
      this.checked = this.value;
    },
  },
  methods: {
    toggleCheckbox() {
      if (this.disabled) {
        return false;
      }
      this.checked = !this.checked;
      this.$emit("input", this.checked);
      this.$emit("change", this.checked);
    },
  },
};
</script>
